/**
 * 服务管理页面Panel配置
 * 包含左侧服务列表和右侧服务详情的Panel配置
 */

import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import type { ButtonConfig } from "@ms/shared-components/containers/ContainerPanel";

// 左侧服务列表Panel配置
export const SERVICE_LIST_PANEL_CONFIG = {
  title: "服务列表",
  height: "100%",
  cardProps: {
    style: {
      width: 400,
      minWidth: 400,
      maxWidth: 400,
      flexShrink: 0,
    },
    styles: {
      body: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      },
    },
  },
} as const;

/**
 * 获取服务列表Panel的按钮配置
 * @param onCreate 创建服务的回调函数
 */
export const getServiceListButtons = (onCreate: () => void): ButtonConfig[] => {
  return [
    {
      key: "create",
      text: "新增",
      type: "primary",
      icon: React.createElement(PlusOutlined),
      onClick: onCreate,
      group: "primary",
    },
  ];
};

// 右侧服务详情Panel配置
export const SERVICE_DETAIL_PANEL_CONFIG = {
  title: "",
  height: "100%",
  cardProps: {
    style: {
      flex: 1,
      minWidth: 0,
    },
  },
} as const;

// 服务列表CompsList配置
export const SERVICE_LIST_CONFIG = {
  showSearch: true,
  height: "100%",
} as const;

